<template>
  <div>
    <div class="mt-1 flex items-center justify-end mr-0 gap-[10px] flex-col sm:flex-row">
      <b-input-group class="input-group-merge w-full sm:max-w-[350px]">
        <b-input-group-prepend is-text>
          <span class="k-search-normal-1" />
        </b-input-group-prepend>
        <b-form-input
          v-model="search"
          placeholder="Cari nama partner"
          class="focus:!shadow-none !text-[#333333] w-full"
          debounce="500"
        />
      </b-input-group>
      <DateRangePicker
        ref="picker"
        v-model="dateRange"
        :locale-data="locale"
        :ranges="ranges"
        :opens="'center'"
        class="withdrawal-date-range w-full sm:max-w-[200px]"
      >
        <template v-slot:input="picker">
          <div class="d-flex justify-content-between align-items-center w-100">
            <div class="mr-1">
              <span
                v-if="
                  YEAR_MONTH_DAY(picker.startDate) === YEAR_MONTH_DAY(today)
                "
                style="color: #828282 !important"
              >
                Hari ini
              </span>
              <span
                v-else-if="
                  YEAR_MONTH_DAY(picker.startDate) === YEAR_MONTH_DAY(last7)
                "
                style="color: #828282 !important"
              >
                7 Hari Terakhir
              </span>
              <span
                v-else-if="
                  YEAR_MONTH_DAY(picker.startDate) === YEAR_MONTH_DAY(last30)
                "
                style="color: #828282 !important"
              >
                30 Hari Terakhir
              </span>
              <span
                v-else-if="
                  YEAR_MONTH_DAY(picker.startDate) ===
                    YEAR_MONTH_DAY(firstDateOfMonth) &&
                    YEAR_MONTH_DAY(picker.endDate) === YEAR_MONTH_DAY(today)
                "
                style="color: #828282 !important"
              >
                Bulan ini
              </span>
              <span
                v-else
                style="color: #828282 !important"
              > Custom </span>
            </div>
            <img
              src="https://storage.googleapis.com/komerce/assets/icons/calendar.png"
              alt="Komerce"
            >
          </div>
        </template>
      </DateRangePicker>
      <b-form-select
        v-model="categoryFilter"
        placeholder="Pilih Status"
        :options="categoryOptions"
        class="w-full  sm:max-w-[200px]"
      />
      <b-form-select
        v-model="statusFilter"
        placeholder="Pilih Status"
        :options="statusOptions"
        class="w-full  sm:max-w-[150px]"
      />
      <img
        v-b-tooltip.hover.top="'Reset Filter'"
        class="cursor-pointer"
        src="https://storage.googleapis.com/komerce/assets/icons/refresh-2.svg"
        alt="Komerce"
        @click="handleResetFilter"
      >
    </div>
    <b-table
      :items="fetcher ? fetcher.data : []"
      :fields="fields"
      class="mt-1"
      responsive
      show-empty
    >
      <template #cell(submission_type)="data">
        <div style="min-width: 150px">
          {{ data.item.submission_type }}
        </div>
      </template>
      <template #cell(submission_date)="data">
        <div style="min-width: 150px">
          {{ DAY_MONTH_YEAR(data.item.submission_date) }}
          <br>
          <span style="color: #828282">{{ TIME(data.item.submission_date) }}</span>
        </div>
      </template>
      <template #cell(warehouse_logo_url)="data">
        <div class="flex items-center">
          <BAvatar :src="data.item.warehouse_logo_url" />
          <div class="ml-1">
            <h5 class="text-black m-0">
              {{ data.item.warehouse_name }}
            </h5>
            <span class="text-gray-500">{{ data.item.warehouse_city }}</span>
          </div>
        </div>
      </template>
      <template #cell(partner_logo_url)="data">
        <div class="flex items-center">
          <BAvatar :src="data.item.partner_logo_url" />
          <div class="ml-1">
            <h5 class="text-black m-0">
              {{ data.item.partner_name }}
            </h5>
            <span class="text-gray-500">{{ data.item.partner_city }}</span>
          </div>
        </div>
      </template>
      <template #cell(status)="data">
        <b-row
          :class="classWarehouse(data.item.status)"
          style="min-width: 150px"
        >
          {{ data.item.status }}
        </b-row>
      </template>
      <template #cell(detail)="data">
        <span
          style="color: #f95031"
          class="cursor-pointer"
          @click="handleClick(data.item)"
        >
          Detail
        </span>
      </template>
      <template #empty>
        <TablePaginationState
          :fetcher="fetcher"
          @retry="handleRetry"
        />
      </template>
      <template #custom-foot>
        <tr ref="scrollSentinel">
          <td
            :colspan="fields.length"
            class="text-center py-2 border-0"
          >
            <TablePaginationState
              :fetcher="fetcher"
              is-footer
              @retry="handleRetry"
            />
          </td>
        </tr>
      </template>
    </b-table>
  </div>
</template>

<script>
import { axiosIns } from '@/libs/axios'
import DateRangePicker from 'vue2-daterange-picker'
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'
import {
  firstDateOfMonth,
  komshipDate,
  last7,
  last30,
  lastDateOfMonth,
  today,
} from '@/store/helpers'
import {
  LABELDAY, LABELMONTH, YEAR_MONTH_DAY, DAY_MONTH_YEAR, TIME,
} from '@/libs/filterDate'
import TablePaginationState from './TablePaginationState.vue'
import { fieldList, statusOptions, categoryOptions } from '../config'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  components: {
    DateRangePicker,
    TablePaginationState,
  },
  data() {
    return {
      activeTab: this.$route.query.tab || 'partner',
      fetcher: null,
      observer: null,
      fields: fieldList,
      statusFilter: null,
      categoryFilter: null,
      statusOptions,
      categoryOptions,
      dateRange: {
        startDate: last30,
        endDate: today,
      },
      locale: {
        format: 'dd/mm/yyyy',
        daysOfWeek: LABELDAY,
        monthNames: LABELMONTH,
      },
      ranges: {
        'Hari ini': [today, today],
        '7 Hari Terakhir': [last7, today],
        '30 Hari terakhir': [last30, today],
        'Bulan ini': [firstDateOfMonth, today],
        'Custom ': [komshipDate, today],
      },
      today,
      last7,
      last30,
      lastDateOfMonth,
      komshipDate,
      firstDateOfMonth,
      YEAR_MONTH_DAY,
      DAY_MONTH_YEAR,
      TIME,
      resetFilter: true,
      search: null,
    }
  },
  computed: {
    isKonfirmasi() {
      return this.activeTab === 'konfirmasi'
    },
    isPengajuan() {
      return this.activeTab === 'pengajuan'
    },
  },
  watch: {
    categoryFilter: {
      handler() {
        this.loadData({ reset: true })
      },
    },
    statusFilter: {
      handler() {
        this.loadData({ reset: true })
      },
    },
    dateRange: {
      handler() {
        this.loadData({ reset: true })
      },
    },
    search: {
      handler() {
        this.loadData({ reset: true })
      },
    },
  },
  created() {
    this.initializeFetcher()
  },
  mounted() {
    this.initObserver()
    this.loadData({ reset: true })
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    /**
     * Initializes the paginated fetcher instance with fetch logic for warehouse submissions.
     */
    initializeFetcher() {
      const fetchFn = async ({ offset, limit, ...options }) => {
        const url = '/v1/warehouse/submission'
        const params = {
          submission_type: options.categoryFilter ?? '',
          submission_status: options.statusFilter ?? '',
          start_date: options.startDate ? YEAR_MONTH_DAY(options.startDate) : '',
          end_date: options.endDate ? YEAR_MONTH_DAY(options.endDate) : '',
          partner_name: options.search || undefined,
          offset,
          limit,
        }
        const res = await axiosIns.get(url, { params })
        const items = res.data?.data || []
        return { data: items }
      }
      this.fetcher = createPaginatedFetcher(fetchFn, 0, 20)
    },
    /**
     * Triggers data fetching using current filter parameters.
     * @param {Object} [options]
     * @param {boolean} [options.reset=false] Whether to reset pagination offset and clear existing data.
     */
    loadData({ reset = false } = {}) {
      if (!this.fetcher) return
      this.fetcher.fetchData({
        reset,
        options: {
          categoryFilter: this.categoryFilter,
          statusFilter: this.statusFilter,
          startDate: this.dateRange?.startDate,
          endDate: this.dateRange?.endDate,
          search: this.search,
        },
      })
    },
    /**
     * Retries fetching data when an error occurs.
     * Resets offset if no data exists, otherwise appends to current list.
     */
    handleRetry() {
      if (!this.fetcher) return
      const reset = this.fetcher.data.length === 0
      this.loadData({ reset })
    },
    /**
     * Initializes IntersectionObserver on the scroll sentinel element for infinite scrolling.
     */
    initObserver() {
      const sentinel = this.$refs.scrollSentinel
      if (!sentinel) return
      this.observer = new IntersectionObserver(
        entries => {
          const entry = entries[0]
          if (entry.isIntersecting && this.fetcher && !this.fetcher.isLoading && this.fetcher.hasMore) {
            this.loadData()
          }
        },
        { threshold: 0.1 },
      )
      this.observer.observe(sentinel)
    },
    classWarehouse(status) {
      if (status === 'Sedang Diajukan') {
        return 'isBeingSubmitted'
      }
      if (status === 'Disetujui') {
        return 'approve'
      }
      if (status === 'Ditolak') {
        return 'reject'
      }
      return ''
    },
    handleClick(data) {
      const { id } = data
      this.$router.push({
        path: `/history-submission/${id}`,
      })
    },
    handleResetFilter() {
      this.categoryFilter = null
      this.statusFilter = null
      this.dateRange = { startDate: last30, endDate: today }
      this.search = undefined
      this.loadData({ reset: true })
    },
  },
}
</script>
<style scoped>
.isBeingSubmitted {
  background-color: #fff2e2;
  color: #fba63c;
  border-radius: 20px;
  padding: 0 10px;
  justify-content: center;
}
.approve {
  background-color: #dcf3eb;
  color: #34a770;
  border-radius: 20px;
  padding: 0 10px;
  justify-content: center;
}
.reject {
  background-color: #ffeded;
  color: #e31a1a;
  border-radius: 20px;
  padding: 0 10px;
  justify-content: center;
}
</style>
